export default {
  computed: {
    $getTypes () {
      let list = {}

      this.$store.state.apiData.objects.forEach((object) => {
        let type = object.building_type
        if(!list[type]){
          list[type] = type
        }
      })

      return list
    },
    $filteredObjectIds () {
      return this.$filteredObjects.map((object) => {
        return object.id
      })
    },
    $filtersActive () {
      return this.$store.state.filtersActive
    },
    $filteredObjects () {
      let objects = this.$store.state.apiData.objects
      let filters = Object.entries(this.$store.state.filters)
      objects = objects.filter((object) => {
        return filters.every((filter) => {
          if (filter[1]) {
            let keys = filter[0].split('|')
            let toFilter = filter[1]
            let value = object
            keys.forEach((key) => {
              value = value[key]
            })

            // Between filter
            if (typeof toFilter === 'object' && toFilter.length === 2 && typeof toFilter[0] === 'number'){
              value = parseInt(value)
              if(value < toFilter[0] || value > toFilter[1]){
                return false
              }
              // In list filter
            } else if(typeof toFilter === 'object' && toFilter.length > 0){
              return toFilter.includes(parseInt(value)) || toFilter.includes(value.toString())
            }
          }
          return true
        })
      })

      return objects
    },
  }
}



